module.exports = __webpack_public_path__ + "static/media/list.377c4959.svg";